import React from 'react'
import Hero from './Hero'
import Demo from './Demo'
import NewPricing from './Pricing'
import { Footer } from './Footer'
import Navbar from './Navbar'
import Faqs from './Faqs'

export default function LandingPage() {
	return (
		<div className="overflow-x-hidden min-h-screen">
			<Navbar />
			<main className="overflow-x-hidden">
				<Hero />
				<Demo />
				<NewPricing />
				<Faqs />
				<Footer />
			</main>
		</div>
	)
}
